// eslint-disable
/*
    
    THIS FILE IS AUTO-GENERATED!
    LOOK "metadata.template.ts" FOR MORE!
    
*/
import type { PackageEnvironment } from '@technocom/core';

export const metadata: PackageEnvironment = {
  packageName: 'migrant',
  displayName: 'Информационная система «Мигрант»',
  description: 'Клиентское приложение ведомственной ИС Департамента труда и занятости населения ХМАО-Югры «Мигрант»',
  timestamp: '2026-10-15T09:43:00.211+05:00',
  version: '2.1.0',
  commit: '83f3e56',
};
